import { render, staticRenderFns } from "./RchGiftReceipt.vue?vue&type=template&id=5847c440&scoped=true&"
import script from "./RchGiftReceipt.vue?vue&type=script&lang=js&"
export * from "./RchGiftReceipt.vue?vue&type=script&lang=js&"
import style0 from "./RchGiftReceipt.vue?vue&type=style&index=0&id=5847c440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847c440",
  null
  
)

export default component.exports